import PropTypes from 'prop-types';

import styled from 'styled-components';

const Text = styled.span`
  color: ${props => props.theme.colors[props.color] || props.color};
  font-family: ${props => props.theme.fonts[props.font]};
  line-height: ${props => props.lineHeight || props.size || '16px'};
  font-size: ${props => props.size || '16px'};
  font-weight: ${props => (props.bold ? 'bold' : 'inherit')};
  font-style: ${props => (props.italic ? 'italic' : 'inherit')};
  letter-spacing: ${props => props.spacing || 'normal'};
  word-wrap: break-word;
  white-space: ${props => props.whiteSpace || 'normal'};
`;

Text.propTypes = {
  font: PropTypes.oneOf(['regular', 'caption']),
  color: PropTypes.string,
  size: PropTypes.string,
  lineHeight: PropTypes.string,
  spacing: PropTypes.string,
  bold: PropTypes.bool,
  italic: PropTypes.bool,
  whiteSpace: PropTypes.string
};

Text.defaultProps = {
  font: 'regular',
  color: 'inherit',
  size: 'default',
  lineHeight: null,
  spacing: null,
  bold: false,
  italic: false,
  whiteSpace: null
};

export default Text;



// WEBPACK FOOTER //
// ./src/components/units/Text/Text.js